import React, { createContext, useContext, useState, ReactNode } from "react";

interface LoaderContextType {
  loader: boolean;
  setLoader:React.Dispatch<React.SetStateAction<boolean>>;
}

const LoaderContext = createContext<LoaderContextType>({
  loader: false,
  setLoader: () => {},
});

interface LoaderProviderProps {
  children: ReactNode;
}

export const LoaderProvider: React.FC<LoaderProviderProps> = ({
  children,
}) => {
  const [loader, setLoader] = useState(false);
  return (
    <LoaderContext.Provider
      value={{
        loader,
        setLoader,
      }}
    >
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);
